import { useMutation } from '@tanstack/react-query'

import { apiClient } from '../apiClient'

export function useCheckOut(onError?: (error: unknown) => void) {
  return useMutation({
    mutationFn: async () => {
      const { data } = await apiClient.post('/int/v3/dispatcher/checkout')
      return data
    },
    onError,
  })
}
